var Media = Media || {};

module.exports = () => {
	// var $ = jQuery;
	Media = function(elem) {
		var elementNode;
		if (typeof elem === "string")
		{
			elementNode = $(elem);
		}
		else if (typeof elem === "object")
		{
			elementNode = elem;
		}

		return {
			isVideo: false,
			node: {
				muted: false,
				currentTime: 0,
				src: null,
				play: function() {},
				pause: function() {},
			},
			get: function() {
				this.node = elementNode.get(0);

				if (typeof this.node !== "undefined")
					this.isVideo = true;

				return this;
			},
			src: function(file) {
				if (this.isVideo) this.node.src = file;

				return this;
			},
			mute: function(bool) {
				if (this.isVideo) this.node.muted = bool;

				return this;
			},
			getMute: function() {
				if (this.node.muted)
					return false;

				return true;
			},
			setCurrentTime: function(numeric) {
				if (this.isVideo) this.node.currentTime = numeric;

				return this;
			},
			getCurrentTime: function() {
				if (this.isVideo) return this.node.currentTime;

				return this;
			},
			load: function() {
				if (this.isVideo)
					return this.node.load();

				return false;
			},
			play: function() {
				if (this.isVideo)
					return this.node.play();

				return false;
			},
			pause: function() {
				if (this.isVideo)
					return this.node.pause();

				return false;
			},
			getNode: function() {
				if (this.isVideo)
					return $(this.node);

				return false;
			},
			isDisplay: function(val) {
				if (this.isVideo)
				{
					if (elementNode.css('display') === val)
					{
						return true;
					}
					else
					{
						return false;
					}
				}

				return false;
			},
			show: function(speed) {
				if (this.isVideo)
				{
					var speed = (speed) ? speed : 0;
					elementNode.show(speed);
				}
			},
			hide: function(speed) {
				if (this.isVideo)
				{
					var speed = (speed) ? speed : 0;
					elementNode.hide(speed);
				}
			}
		};
	};

	window.Media = Media;

	return Media;
};
